import { getMergeViewEnabledAccount } from 'owa-truetime';
import updateMergedViewAvailabilityInitialState from '../data/mutators/updateMergedViewAvailabilityInitialState';
import updateMergedViewAvailabilityCurrentState from '../data/mutators/updateMergedViewAvailabilityCurrentState';
import { initializeTrueTimeStore } from 'owa-truetime';

/**
 * Gets the Time Profile information from server and sets the MergedViewEnabled account
 */
export default async function initMergedViewAvailabilityOption() {
    initializeTrueTimeStore();
    const account = getMergeViewEnabledAccount();

    updateMergedViewAvailabilityInitialState(account);
    updateMergedViewAvailabilityCurrentState(account);
}
